import React, { useState, useEffect } from 'react'
import { scrollChat } from '../fuctions/scrollChat';
import { ListaMensajes } from '../components/listas/ListaMensajes'

export const useMensajes = (props) => {

  const { Usuario } = props;

    const [TextMensaje, setTextMensaje] = useState("")
    const onInputChange = ({ target }) => {
      const { name, value } = target;
      setTextMensaje(value);

  }
    
    let lista = ListaMensajes();
    const [ListaMen, setListaMen] = useState(lista)
    const addMensaje = () => {
        setListaMen(lis => [...lis, {
          mensaje:TextMensaje,
          horaMensaje:"12:23",
          tipo:"mensajeEntrada"
        }])
        setTextMensaje("")
    }
    const handleKeypress = e => {
      if (e.key==="Enter") {
          addMensaje(e)
      }
  };

  useEffect(() => {
    scrollChat()
  }, [ListaMen])
  
  return {
    ListaMen:ListaMen,
    addMensaje:addMensaje,
    TextMensaje:TextMensaje,
    setTextMensaje:setTextMensaje,
    onInputChange:onInputChange,
    handleKeypress:handleKeypress,

  }

}
